export default "__VITE_ASSET__xbIY4g41__"